import { SensorPortCommunicationMode } from "../../../portConfigs.js";
import { combineValidators, sensorParameterNumericValidators } from "../../SensorConfigurationParameterHelpers.js";
import { SensorParameterConfigBase, SensorParameterValueType } from "../../SensorConfigurationTypes.js";
import type { SensorClusterConfig } from "../types.js";

const sensoterraSingleDepthParams = {
    depth: {
        key: "depth",
        type: SensorParameterValueType.NUMBER,
        name: "Installation Depth",
        description: "Depth of the probe below the soil surface, in meters.",
        defaultValue: 0,
        validator: combineValidators(
            sensorParameterNumericValidators.isNumber,
            sensorParameterNumericValidators.isGreaterThanOrEqualToZero,
        ),
        mustBeNonNegative: true,
        mustBeInteger: false,
        parameterUnitCategory: "depth",
    },
} as const satisfies Record<string, SensorParameterConfigBase<number>>;

export const sensoterraClusterConfigs: Record<string, SensorClusterConfig<typeof sensoterraSingleDepthParams>> = {
    sensoterra_single_depth: {
        communicationMode: SensorPortCommunicationMode.DIGITAL,
        requiredSubChannels: [0],
        optionalSubChannels: [],
        isPermanentlyAttached: true,
        parameterConfigs: sensoterraSingleDepthParams,
        manufacturerName: "Sensoterra",
        modelName: "Sensoterra SD",
        friendlyName: "Sensoterra Single Depth Sensor",
        friendlyShortName: "Sensoterra SD",
        generateSensorElements: ({ depth }) => [
            {
                sensorElementConfigKey: "volumetricWaterContent",
                subChannel: 0,
                parameters: {},
                position: { depth },
                legalConvertedRange: [0, 100],
            },
        ],
    },
};
